module.exports = __webpack_public_path__ + "static/React-abb94b26a2fdd0a843375db825f85b8b.mp4";